import PropTypes from "prop-types";

import '../../index.css';
export const BalanceSheetTemplate=(props) =>{

    return (
        <>
            <div className="card bg-surface-80  flex flex-column dark:bg-surface-950   w-full ">
                {/*Heading*/}
                <div className="flex flex-column  w-full">
                    <div
                        className="text-surface-900 dark:text-surface-0 font-bold text-4xl  text-center">Balance
                        Sheet
                    </div>
                    <div className="text-surface-500 dark:text-surface-400 text-md text-center ">{props.bs.month}</div>

                    {/*Profit*/}
                    <div className="flex flex-row  gap-8 w-full mx-auto">
                        <div
                            className=" flex-1 pl-4 pr-4 flex rounded-2xl flex-column bg-surface-0 dark:bg-surface-800 shadow-sm gap-6">
                            <div className="flex flex-column gap-2">
                                <h4 className="text-surface-900 dark:text-surface-0 font-medium text-md leading-tight">Profit
                                    & Loss</h4>
                                <table className="table table-striped ">
                                    <tbody>
                                    <tr className="w-full">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Opening Stock</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-right text-xs Leading-tight">{props.bs.opening}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Purchase</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 t font-small text-xs leading-tight">{props.bs.purchase}</span>
                                        </td>
                                    </tr>
                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Closing Stock</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.closing}</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs text-start leading-tight">Cost of Sale</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs text-end leading-tight">-{props.bs.saleCost}</span>
                                        </td>
                                    </tr>
                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Gross Profit</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.gross}</span>
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Total Sale</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.sale}</span>
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Expenses</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">-{props.bs.expenses}</span>
                                        </td>
                                    </tr>
                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Net Profit</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.net}</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div
                            className=" flex-1 pl-4 pr-4 flex rounded-2xl flex-column bg-surface-0 dark:bg-surface-800 shadow-sm gap-6">
                            <div className="flex flex-column gap-2">
                                <h4 className="text-surface-900 dark:text-surface-0 font-medium text-md leading-tight">Assets</h4>
                                <table className="table table-striped ">
                                    <tbody>
                                    <tr className="w-full">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Properties & Fixed</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs Leading-tight">{props.bs.asset}</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Cash in Hand</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.cash}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Cheques ending</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.cheque}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs text-start leading-tight">Receivable</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs text-end leading-tight">{props.bs.receivable}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Payable</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.payable}</span>
                                        </td>
                                    </tr>

                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Bank</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.bank}</span>
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Import</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.import}</span>
                                        </td>
                                    </tr>
                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Total Asset</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.worth}</span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div
                            className=" flex-1 pl-4 pr-4 flex rounded-2xl flex-column bg-surface-0 dark:bg-surface-800 shadow-sm gap-6">
                            <div className="flex flex-column gap-2">
                                <h4 className="text-surface-900 dark:text-surface-0 font-medium text-md leading-tight">Capital</h4>
                                <table className="table table-striped ">
                                    <tbody>

                                    <tr className="w-full">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Opening Capital </span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs Leading-tight">{props.bs.openingCapital}</span>
                                        </td>
                                    </tr>

                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Net Profit</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.net}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Gain</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">{props.bs.gains}</span>
                                        </td>
                                    </tr>
                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs text-start leading-tight">Drawing</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs text-end leading-tight">-{props.bs.drawings}</span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th><span>-</span></th>
                                        <td className = "text-end"><span/></td>
                                    </tr>

                                    <tr>
                                        <th><span>-</span></th>
                                        <td><span/></td>
                                    </tr>

                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span>-</span></th>
                                        <td><span/></td>
                                    </tr>
                                    <tr className="border-bottom-0 bg-primary-500 dark:bg-primary-600  ">
                                        <th><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">Total Asset</span>
                                        </th>
                                        <td className = "text-end"><span
                                            className="text-surface-900 dark:text-surface-0 font-small text-xs leading-tight">
                                            {props.bs.leftTotal}
                                        </span>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )

}
BalanceSheetTemplate.propTypes = {
    bs: PropTypes.object.isRequired,
}
